<template>
  <tm-module-error-boundary>
    <router-view v-bind="$attrs">
      <template
        v-for="(_, name) in $slots"
        v-slot:[name]="slotData"
      >
        <slot
          :name="name"
          v-bind="slotData ?? {}"
        />
      </template>
    </router-view>
  </tm-module-error-boundary>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import TmModuleErrorBoundary from '@/components/shared/TmModuleErrorBoundary.vue'
</script>
